<template>
  <modal
    top="0"
    height="100%"
    width="100%"
    left="0"
    name="show-product-roomscene-view-hero-modal"
    class="productimage-hero-modal"
    data-html2canvas-ignore="true"
    :adaptive="true"
    :scrollable="true"
  >
    <div class="productimage-hero-modal-wrapper">
      <div class="productimage-hero-modal-close-btn">
        <button class="btn button-close" type="button" @click="hideHeroModal">
          <span
            class="png-icon png-icon-icons-glyph--k-close"
            aria-label="Close hero modal"
          />
        </button>
      </div>
      <div class="productimage-hero-modal-row">
        <div class="productimage-hero-modal-main-col">
          <!-- swatch -->
          <template v-if="viewProductType === 'swatch'">
            <div class="product-room-scene-viewer-warpper">
              <div class="product-room-scene-viewer-box">
                <div class="product-room-scene-viewer-zoominout-col">
                  <button class="btn button-plus shadow" type="button" @click="zoomIn" :class="{'disabled': zoomLevel === maxZoomLevel}">
                    <span class="plus-sm-icon png-icon png-icon-icons-glyph--k-plus wf-product-refinement-list-header-toggle-inactive"/>
                  </button>
                  <button class="btn button-minus shadow" type="button" @click="zoomOut" :class="{'disabled': zoomLevel === minZoomLevel}">
                    <span class="plus-sm-icon png-icon png-icon-icons-glyph--k-minus wf-product-refinement-list-header-toggle-inactive"/>
                  </button>
                </div>
                <div class="product-room-scene-viewer-image-type-toggler" v-if="!hideSwatchMultiTileButtons.includes(productData.productTypeDesc.toLowerCase())">
                  <button class="wf-product-room-scene-swatch border-0 shadow" :class="isMultitile === false ? 'font-weight-bold' : 'color-light-grey'" @click="imageTypeToggler(false)">
                    {{ $resourceString['product.Details.Swatch.Label'] }}
                  </button>
                  <button class="wf-product-room-scene-multiple border-0 shadow font-weight-bold" :class="isMultitile === true ? 'font-weight-bold' : 'color-light-grey'" @click="imageTypeToggler(true)">
                    {{ $resourceString['product.Details.MultiTile.Label'] }}
                  </button>
                </div>
                <div class="product-room-scene-viewer-swatch-image">
                  <img class="product-swatch-image-viewer swatch-zoomable"
                    :src="isMultitile === true 
                      ? getInstallImgUrl(selectedInstallationMethod.name, 2000)
                      : $helpers.getColorThumbnailImageUrl(
                        sellingStyleNumber,
                        selectedColor.colorNumber,
                        selectedProduct.productSizeImperial.toLowerCase().replace(/ /g, '').replace('x', '-').replace(/[a-zA-Z]/g, '').replace('-', 'x'),
                        productData.productTypeDesc
                      )
                    "
                    alt="img" 
                    @error="handleThumbnailImageError"                                    
                  />
                </div>
              </div>             
            </div>
          </template>

          <!-- room scene -->
           <template v-if="viewProductType === 'roomscene'">
              <div class="product-room-scene-slider-view-wrap">
                <div class="product-room-scene-slider-view">
                  <!-- slider view controls -->
                   <div class="product-room-scene-slider-view-controls">                       
                      <div class="product-room-scene-slider-view-controls-button" v-if="roomScenes.length > 1">
                        <button class="btn button-previous"type="button" @click="setPreviousRoomScene">
                          <span class="png-icon png-icon-icons-glyph--k-chevron-left" aria-label="Previous room scene"/>
                        </button>
                        <button class="btn button-next" type="button" @click="setNextRoomScene">
                          <span class="png-icon png-icon-icons-glyph--k-chevron-right" aria-label="Next room scene"/>
                        </button>
                      </div>
                      <div class="product-room-scene-slider-view-controls-pagination">
                        <ul>
                          <li v-for="(roomScene, index) in roomScenes" :key="roomScene.data">
                            <button class="btn pagination-item-button" type="button" :class="roomScene === selectedRoomScene ? 'pagination-item-button-active' : ''" :aria-label="`View room scene number ${roomScene}`" @click="setPaginationIndex(index)" />
                          </li>
                        </ul>
                      </div>

                   </div>
                   <!-- slider view -->
                   <div class="product-room-scene-slider-view-container">
                    <wf-load-image
                      :wrapper-class="'product-room-scene-slider-view-image-wrapper'"
                      :image-class="`product-room-scene-slider-view-image`"
                      id="product-room-scene-slider-view-image"
                      :src="getRoomSceneImageUrl(selectedRoomScene, 3000)"
                      :alt="''"
                      :image-load="applyPanzoom"
                    />
                   </div>
                </div>
              </div>
           </template>

          <!-- 360 view -->
          <template v-if="viewProductType === '360Video' && videoURL">
            <div class="product-360-video-wrapper">
                <video class="rotation-video" controls autoplay loop>
                  <source :src="videoURL" type="video/mp4" />
                </video>
            </div>
          </template>
        </div>
        <div class="productimage-hero-modal-aside-bar">
          <div class="productimage-hero-modal-install-methods" v-if="productData.productTypeDesc.toLowerCase() != $resourceString['productCategory.ResinousFlooring'].toLowerCase()">
            <!-- installation method -->
            <div
              class="dropdown-underline font-16 pb-3"
              :class="{ expanded: expandedFormGroup === 'installMethod' }"
            >
              <label
                class="installation-methods-label"
                for="install-method-select"
              >
                {{
                  $resourceString[
                    "product.details.room.scene.installation.method"
                  ]
                }}
              </label>
              <select
                class="border-0 cursor-pointer custom-dropdown text-uppercase"
                v-model="formSelectedInstallationMethod"
              >
                <option
                  v-for="installationMethod in installationMethods"
                  :key="installationMethod.code"
                  :value="
                    installationMethod.tricycleCode || installationMethod.code
                  "
                >
                  {{ installationMethod.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="productimage-hero-modal-color-list-wrap">
            <div class="productimage-hero-modal-color-list">
              <pc-product-room-scene-colors
                :installationMethods="installationMethods"
                :product="product"
                :segments="segments"
                :segmentrooms="segmentrooms"
                :collectionsegments="collectionsegments"
                :roomscenenumbers="roomscenenumbers"
                :segmentRoomScenes="segmentRoomScenes"
                :mappedColors="mappedColors"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Panzoom from "@panzoom/panzoom";
import PcProductRoomSceneColors from "./pc-product-room-scene-colors.vue";
import WFLoadImage from "../wf-load-image.vue";
import { globalIcons } from "../../../constants/global";

let panzoomInstance = null;
export default {
  props: [
    "installationMethods",
    "expandedFormGroup",
    "updateQueryStringParameters",
    "product",
    "segments",
    "segmentrooms",
    "collectionsegments",
    "roomscenenumbers",
    "segmentRoomScenes",
    "mappedColors",
    "hideModal",
    "viewProductType",
    "isMultitile",
    "toggleModeForProductImage",
    "getInstallImgUrl",
    "getRoomSceneImageUrl",
    "hideSwatchMultiTileButtons",
    "videoURL",
  ],
  components: {
    "pc-product-room-scene-colors": PcProductRoomSceneColors,
    "wf-load-image": WFLoadImage,
  },
  data() {
    return {
      zoomLevel: 0,
      maxZoomLevel: 3,
      minZoomLevel: -3,
      defaultImage: globalIcons.defaultImage,
      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
    }
  },
  computed: {
    ...mapGetters({
      selectedInstallationMethod: "productDetail/installationMethod",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      selectedColor: "productDetail/color",
      selectedProduct: "productDetail/selectedProduct",
      productData: "productDetail/productData",
      selectedRoomScene: "productDetail/roomScene",
      roomScenes: "productDetail/roomScenes",
      roomSceneIndex: "productDetail/roomSceneIndex",
    }),
    formSelectedInstallationMethod: {
      get() {
        return (
          this.selectedInstallationMethod.tricycleCode ??
          this.selectedInstallationMethod?.code
        );
      },
      set(value) {
        let installationMethod = this.installationMethods.find(
          i => (i.tricycleCode ?? i.code) === value
        );
        this.setInstallationMethod(installationMethod);
        this.updateQueryStringParameters(
          this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME,
          installationMethod.name
        );
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResizeForPanzoom);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResizeForPanzoom);
  },
  methods: {
    ...mapActions({
      setInstallationMethod: "productDetail/setInstallationMethod",
      setRoomSceneIndex: "productDetail/setRoomSceneIndex",
    }),
    hideHeroModal() {
      this.hideModal();
      this.zoomLevel = 0;
    },
    handleResizeForPanzoom() {
      this.windowSize.width = window.innerWidth;
      this.windowSize.height = window.innerHeight;
      if(this.windowSize.width || this.windowSize.height)
      this.applyPanzoom();
    },
    imageTypeToggler(type) {
      if(type) {
        this.toggleModeForProductImage(true);
      } else {
        this.toggleModeForProductImage(false);
      }
      this.applyPanzoom();
    },
    handleThumbnailImageError(event) {
      if(event.target.src.toLowerCase().includes("thumbnail") || event.target.src.toLowerCase().includes("installs")){
        event.target.src = this.defaultImage;
      }
      else{
        event.target.src = this.$helpers.getColorThumbnailImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber
        );
      }
    },
    zoomIn() {
      if (this.zoomLevel < this.maxZoomLevel) {
        this.zoomLevel++;
        this.updateZoom();
      }
    },
    zoomOut() {
      if (this.zoomLevel > this.minZoomLevel) {
        this.zoomLevel--;
        this.updateZoom();
      }
    },
    updateZoom() {
      var element = document.querySelector(".swatch-zoomable");
      let scale = 1 + (this.zoomLevel * 0.1);
      element.style.transform = "scale(" + scale + ")";
    },
    applyPanzoom: function() {
      if (panzoomInstance) {
        panzoomInstance.destroy();
      }
      const parentNode = document.getElementById('product-room-scene-slider-view-image');
      const imageNode = document.querySelector('#product-room-scene-slider-view-image img');
      if((parentNode && parentNode.offsetHeight) && (imageNode && imageNode.offsetHeight)) {
        const startY = ((parentNode.offsetHeight - imageNode.offsetHeight) / 2)
        const isParentLarge = parentNode.offsetHeight > imageNode.offsetHeight;     
        try {
          panzoomInstance = Panzoom(imageNode, {
            startScale: 1,
            startX: 0,
            startY: startY,
            setTransform: (imageNode, { scale, x, y }) => {
              panzoomInstance.setStyle('transform', `scale(${scale}) translate(${x}px, ${isParentLarge ? startY : y}px)`)
            },
            contain: "outside"
          });
        } catch(error) { }
      }
      
    },
    setPaginationIndex(index) {
      this.updateRoomSceneIndexWithParams(index, index)
    },
    setPreviousRoomScene: function() {
      let index = (this.roomSceneIndex - 1) % this.roomScenes.length;
      index = index < 0 ? 0 : index;
      this.updateRoomSceneIndexWithParams(index, this.roomSceneIndex)
    },
    setNextRoomScene: function() {
      let index = (this.roomSceneIndex + 1) % this.roomScenes.length;
      index = index >= this.roomScenes.length ? this.roomScenes.length - 1 : index;
      this.updateRoomSceneIndexWithParams(index, this.roomSceneIndex)
    },
    updateRoomSceneIndexWithParams(index, roomsceneindex) {
      this.setRoomSceneIndex(index);
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[roomsceneindex].data
      );
    }

  },
  watch: {
    videoURL: {
      handler(newVal) {
        if (newVal && this.$el && typeof this.$el.querySelector === 'function') {
          const videoElement = this.$el.querySelector("video");
          if (videoElement) {
            videoElement.load();
          }
        }
      },
      immediate: true
    }
  }
};
</script>
